import type { FlagConfiguration } from '@atlassian/jira-flags';
import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	componentAddedTitle: {
		id: 'project-components.flags.component-added-title',
		defaultMessage: '{name} added',
		description: "Flag's title - appears when component with given {name} was created.",
	},
});

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (name: string): FlagConfiguration => ({
	type: 'success',
	isAutoDismiss: true,
	title: [messages.componentAddedTitle, { name }],
	messageId: 'project-directories.components.flags.add.flag.success',
	messageType: 'transactional',
});
